export default "__VITE_ASSET__DbJeC17M__"